export default "/images/percent.svg?31bf0cf98f4018d67faca7f990df2759";